import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="px-6 py-8 max-w-3xl mx-auto" data-id="element-146">
      <FadeIn data-id="element-147">
        <div className="space-y-5 text-lg md:text-xl leading-relaxed text-[#2D2A26]" data-id="element-148">
          <p data-id="element-149">Son las 11:47 PM.</p>

          <p data-id="element-150">El mundo a tu alrededor está en silencio.</p>

          <p className="font-bold text-[#4A5D3A]" data-id="element-151">
            Este debería ser TU momento.
          </p>

          <p data-id="element-152">Pero no lo es.</p>

          <img src="https://cdn.magicpatterns.com/uploads/3vL1eci6CW3XYWGky5GZSu/imagen_2_para_la_pagina_de_venta.png" alt="Mujer despierta en la cama sin poder dormir" className="w-full max-w-xl mx-auto rounded-2xl shadow-lg my-6" data-id="element-153" />

          <p data-id="element-154">
            Porque en el segundo en que tu cabeza tocó la almohada, algo se
            activó.
          </p>

          <p data-id="element-155">
            La lista interminable de pendientes. La conversación que salió mal.
            El miedo silencioso al futuro. La culpa de no haber dado suficiente.
            El mensaje sin responder. La factura sin pagar. La versión de ti que
            sientes que estás perdiendo poco a poco.
          </p>

          <p className="font-bold" data-id="element-156">Tu cuerpo está tirado en la cama.</p>

          <p className="font-bold text-[#9B4F2B]" data-id="element-157">
            Tu mente está corriendo una maratón que nadie ve.
          </p>

          <p data-id="element-158">Y lo más cruel no es el cansancio.</p>

          <p data-id="element-159">
            Lo más cruel es que ya ni recuerdas cómo se siente despertar sin esa
            presión en el pecho.
          </p>

          <p data-id="element-160">
            Como si el agotamiento se hubiera convertido en tu estado normal.
          </p>

          <p className="font-bold text-xl md:text-2xl text-[#4A5D3A] mt-8" data-id="element-161">
            Pero no lo es. Y no tiene que seguir siéndolo.
          </p>
        </div>
      </FadeIn>
    </section>;
}